export class PanelMember {
    panelMemberId: number;
    panelMemberName: string;
    contactNo: number;
    email: string;
    createdId: string;
    constructor(panelMemberId: number, fullName: string, mobile: number, email: string) {
        this.panelMemberId = panelMemberId;
        this.panelMemberName = fullName;
        this.contactNo = mobile;
        this.email = email;
        this.createdId = "Admin";
    }
}
